import {SLQueryParamConfig, slQueryParamConfigMap} from '#/contexts/query-params-provider';
import {ExchangeRoute} from '#/routes/exchange/exchange-route';
import qs from 'query-string';
import {useCallback} from 'react';
import {useNavigate} from 'react-router-dom';
import {DecodedValueMap, encodeQueryParams} from 'use-query-params';

export const useTypedNavigate = (): ((
  pathname: ExchangeRoute,
  queryParams: Partial<DecodedValueMap<SLQueryParamConfig>>,
) => void) => {
  const navigate = useNavigate();

  return useCallback(
    (pathname: ExchangeRoute, queryParams: Partial<DecodedValueMap<SLQueryParamConfig>>) => {
      const encodedQuery = encodeQueryParams(slQueryParamConfigMap, queryParams);

      navigate({
        pathname,
        search: `?${qs.stringify(encodedQuery)}`,
      });
    },
    [navigate],
  );
};
